import { useState } from 'react';

export const useBarChart = () => {
  const [graphData, setGraphData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [yAxis, setYAxis] = useState({ min: -100, max: 100 });

  return {
    graphData,
    loading,
    yAxis,
    setGraphData,
    setLoading,
    setYAxis,
  };
};
